import initContactForm from './contact-form';
import initFeedbackPopup from './feedback-popup';
import initResidentialComplex from './residential-complex';
import initStockSlider from './stock';
import initVideoPlay from './video-list';
import initBanner from './banner';
import initCountdown from './countdown-timer';
import searchForm from './search-form'
import './adfox-check';
import initCardAdvertising from './advertising-block'

export default () => {
  const $search = $('.search');
  $search && searchForm($search);
  initContactForm();
  initFeedbackPopup();
  initResidentialComplex();
  initStockSlider();
  initBanner();
  initVideoPlay();
  initCountdown();
  $('.rc-card') && initCardAdvertising();
};



// WEBPACK FOOTER //
// ./resources/assets/js/blocks/index.js